export default "__VITE_ASSET__etncakyy__"